export * from './DigitalData';
